import React from "react";
import { PageHeader } from "@/components/dashboard/ui";
import { MessageSquare, Phone, Mail } from "lucide-react";
import { Link } from "react-router-dom";

const TEAM = [
  { name: "Dr. Emily Carter", role: "BCBA, Clinical Director", avatar: "/generated/clinician_female.png", tint: "#1a5fd0" },
  { name: "Dr. Patel", role: "Pediatrician", avatar: "/generated/pediatrician_male.png", tint: "#2f9e57" },
  { name: "Sarah Wilson", role: "Parent · Noah's Mom", avatar: "/generated/mom_female.png", tint: "#7c53d6" },
  { name: "Mike Reynolds", role: "3rd Grade Teacher", avatar: "/generated/teacher_male.png", tint: "#e0842f" },
];

export default function CareTeam() {
  return (
    <div className="fade-in">
      <PageHeader title="Care Team" subtitle="The circle of support around every child" />
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-5">
        {TEAM.map((m) => (
          <div key={m.name} className="card-soft card-hover p-6 text-center">
            <img src={m.avatar} alt={m.name} className="h-24 w-24 rounded-full object-cover mx-auto ring-4 ring-white shadow" />
            <h4 className="font-display mt-4 text-[17px] font-bold text-[#10233f]">{m.name}</h4>
            <p className="text-[13px] text-slate-500">{m.role}</p>
            <div className="mt-4 flex justify-center gap-2">
              <Link to="/messages" className="h-9 w-9 rounded-full bg-[#eef5ff] grid place-items-center text-[#1a5fd0] hover:bg-[#e0ecff]"><MessageSquare size={16} /></Link>
              <button className="h-9 w-9 rounded-full bg-[#eef5ff] grid place-items-center text-[#1a5fd0] hover:bg-[#e0ecff]"><Phone size={16} /></button>
              <button className="h-9 w-9 rounded-full bg-[#eef5ff] grid place-items-center text-[#1a5fd0] hover:bg-[#e0ecff]"><Mail size={16} /></button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
